import React from 'react';
import { useTranslation } from 'react-i18next';
import { FallbackContainer, FallbackMsg } from './styles';

const FallbackMessage = () => {
  const { t } = useTranslation();

  return (
    <FallbackContainer>
      <FallbackMsg data-test-role="no-ids-label">
        {t('LPBD.noIdsProvided')}
      </FallbackMsg>
    </FallbackContainer>
  );
};

export default FallbackMessage;
